/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Trial_ActivateInputs */

const en_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Account`)
};

const fr_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le compte`)
};

const de_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto aktivieren`)
};

const it_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva account`)
};

const ru_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать аккаунт`)
};

const es_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar cuenta`)
};

const zh_cn2_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活账户`)
};

const ja_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを有効化`)
};

const hi_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता सक्रिय करें`)
};

const pt_pt2_ccsl_export_trial_activate = /** @type {(inputs: Ccsl_Export_Trial_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar conta`)
};

/**
* | output |
* | --- |
* | "Activate Account" |
*
* @param {Ccsl_Export_Trial_ActivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_trial_activate = /** @type {((inputs?: Ccsl_Export_Trial_ActivateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Trial_ActivateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_trial_activate(inputs)
	if (locale === "de") return de_ccsl_export_trial_activate(inputs)
	if (locale === "it") return it_ccsl_export_trial_activate(inputs)
	if (locale === "ru") return ru_ccsl_export_trial_activate(inputs)
	if (locale === "es") return es_ccsl_export_trial_activate(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_trial_activate(inputs)
	if (locale === "ja") return ja_ccsl_export_trial_activate(inputs)
	if (locale === "hi") return hi_ccsl_export_trial_activate(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_trial_activate(inputs)
	return en_ccsl_export_trial_activate(inputs)
});